import { render } from "./addDocumentToCertification.vue?vue&type=template&id=657032a1&scoped=true&ts=true"
import script from "./addDocumentToCertification.vue?vue&type=script&lang=ts"
export * from "./addDocumentToCertification.vue?vue&type=script&lang=ts"

import "./addDocumentToCertification.vue?vue&type=style&index=0&id=657032a1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-657032a1"]])

export default __exports__